// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-iconbutton_default__dg7do","small":"idt-iconbutton_small__2yvpt"};